/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screen_Done_Body_MapInputs */

const en_us2_onboarding_screen_done_body_map = /** @type {(inputs: Onboarding_Screen_Done_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I marked where it hurts`)
};

const pt_br2_onboarding_screen_done_body_map = /** @type {(inputs: Onboarding_Screen_Done_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquei onde dói`)
};

const es_419_onboarding_screen_done_body_map = /** @type {(inputs: Onboarding_Screen_Done_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqué dónde me duele`)
};

const pt_pt2_onboarding_screen_done_body_map = /** @type {(inputs: Onboarding_Screen_Done_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquei onde dói`)
};

const fr_fr2_onboarding_screen_done_body_map = /** @type {(inputs: Onboarding_Screen_Done_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai indiqué où j'ai mal`)
};

const de_de2_onboarding_screen_done_body_map = /** @type {(inputs: Onboarding_Screen_Done_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe markiert, wo es wehtut`)
};

const it_it2_onboarding_screen_done_body_map = /** @type {(inputs: Onboarding_Screen_Done_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho segnato dove fa male`)
};

/**
* | output |
* | --- |
* | "I marked where it hurts" |
*
* @param {Onboarding_Screen_Done_Body_MapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_screen_done_body_map = /** @type {((inputs?: Onboarding_Screen_Done_Body_MapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screen_Done_Body_MapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_screen_done_body_map(inputs)
	if (locale === "es-419") return es_419_onboarding_screen_done_body_map(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_screen_done_body_map(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_screen_done_body_map(inputs)
	if (locale === "de-DE") return de_de2_onboarding_screen_done_body_map(inputs)
	if (locale === "it-IT") return it_it2_onboarding_screen_done_body_map(inputs)
	return en_us2_onboarding_screen_done_body_map(inputs)
});
export { onboarding_screen_done_body_map as "onboarding.screen_done.body-map" }